import lowerCaseBoolValue from './lowerCaseBoolValue';

const parseDotNotation = (str, val, obj) => {
  let currentObj = obj;
  const keys = str.split('.');
  let i;
  const l = Math.max(1, keys.length - 1);
  let key; // eslint-disable-next-line no-plusplus

  for (i = 0; i < l; ++i) {
    key = keys[i];
    currentObj[key] = currentObj[key] || {};
    currentObj = currentObj[key];
  }

  currentObj[keys[i]] = val; // eslint-disable-next-line no-param-reassign

  delete obj[str];
};

const expander = obj => {
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (key.indexOf('.') !== -1) {
      parseDotNotation(key, obj[key], obj);
    }
  }

  return obj;
};

const normaliseValue = value => {
  try {
    return JSON.parse(lowerCaseBoolValue(value));
  } catch (e) {
    return value;
  }
};

const objectFromKeyCollection = (collection, keyName = 'key', valueName = 'value') => {
  const objectWithDottedKeys = collection.reduce((acc, obj) => {
    const entry = k => Object.entries(obj).find(x => x[0].toLowerCase() === k);

    const key = entry(keyName) && entry(keyName)[1];
    const value = normaliseValue(entry(valueName) && entry(valueName)[1]);
    acc[key] = value;
    return acc;
  }, {});
  const expanded = expander(objectWithDottedKeys);
  return expanded;
};

export default objectFromKeyCollection;
//# sourceMappingURL=objectFromKeyCollection.js.map